module.exports = __webpack_public_path__ + "img/grey.a440a1f6.png";